import {
  inject,
  Injectable,
  Injector,
  runInInjectionContext
} from "@angular/core"
import {
  Auth,
  getIdTokenResult,
  GoogleAuthProvider,
  ParsedToken,
  signInWithEmailAndPassword,
  signInWithPopup,
  user
} from "@angular/fire/auth"
import { Unsubscribe } from "@angular/fire/firestore"
import { Router } from "@angular/router"
import { ToastrService } from "ngx-toastr"
import { BehaviorSubject, Subject } from "rxjs"
import { environment } from "src/environments/environment"

import { DbService } from "./db.service"

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private auth = inject(Auth)
  private router = inject(Router)
  private toastr = inject(ToastrService)
  private dbService = inject(DbService)
  private injector = inject(Injector)

  claims: ParsedToken = {}
  isAdmin = false
  dbCol = "metadata"

  user$ = user(this.auth)
  callback: Record<string, Unsubscribe> = {}

  isLoggedInSubject = new Subject<boolean>()
  claimsSubject = new Subject<ParsedToken>()
  isAdminSubject = new Subject<boolean>()

  brandLocked$ = new BehaviorSubject<boolean>(false)
  brandLockedSubject = new BehaviorSubject<string>("")

  constructor() {
    this.user$.subscribe(async (user) => {
      if (user) {
        runInInjectionContext(this.injector, () => {
          if (!this.callback[user.uid]) {
            this.callback[user.uid] = this.dbService.getSnap<{
              refreshTime: string
              lockedBrand?: string
            }>(this.dbCol, user.uid, async (item) => {
              const data = item.data()

              console.log("data", data)
              if (data?.lockedBrand) {
                this.brandLocked$.next(true)
                this.brandLockedSubject.next(data.lockedBrand)
              } else {
                this.brandLocked$.next(false)
                this.brandLockedSubject.next("")
              }

              try {
                await user.getIdToken(true)
              } catch (err) {
                console.error(err)
                await this.logout()
              }
            })
          }

          getIdTokenResult(user)
            .then((idTokenResult) => {
              this.claims = idTokenResult.claims
              this.isAdmin = !!this.claims["admin"]
              this.isAdminSubject.next(this.isAdmin)
              this.claimsSubject.next(this.claims)
            })
            .catch(async (err) => {
              console.error(err)
              await this.logout()
            })
        })
      } else if (environment.useEmulators) {
        await signInWithEmailAndPassword(
          this.auth,
          "seaders@emulatoruser.com",
          "password"
        )
      } else {
        this.resetState()

        Object.keys(this.callback).forEach((key) => {
          this.callback[key]()
          delete this.callback[key]
        })

        // google.accounts.id.initialize({
        //   client_id: environment.webClientId,
        //   callback: async (response) => {
        //     await signInWithCredential(
        //       this.auth,
        //       GoogleAuthProvider.credential(response.credential)
        //     )
        //   },
        //   auto_select: false,
        //   cancel_on_tap_outside: false,
        //   context: "signin"
        // })

        // google.accounts.id.prompt()
      }
    })
  }

  resetState() {
    this.claims = {}
    this.isAdmin = false

    this.isLoggedInSubject.next(false)
    this.isAdminSubject.next(false)
    this.claimsSubject.next(this.claims)
    this.brandLocked$.next(false)
    this.brandLockedSubject.next("")
  }

  login() {
    return signInWithPopup(this.auth, new GoogleAuthProvider())
  }

  async logout(navigate = true) {
    await this.auth.signOut()

    if (navigate) {
      this.toastr.show("You have been logged out", "Success")
      await this.router.navigate(["/"])
    }
  }
}
